import { CustomEventWithDetail, html, View } from 'rune-ts';
import klass from './CategoryAccordion.module.scss';
import {
  CategoryAccordionItem,
  CategoryAccordionItemChangeEvent,
  CategoryAccordionItemData,
} from './views/CategoryAccordionItem';
import { map, pipe, toArray } from '@fxts/core';

export class CategoryChangeEvent extends CustomEventWithDetail<{
  cate_list_id?: number;
  cate_item_id?: number;
}> {}

interface CategoryAccordionListOption {
  klass?: string;
  cate_list_id?: number;
  cate_item_id?: number;
}

export class CategoryAccordion extends View<CategoryAccordionItemData[]> {
  state: CategoryAccordionListOption;
  activeCategoryAccordionItem: CategoryAccordionItem | undefined;

  AccordionItems: CategoryAccordionItem[];

  constructor(data: CategoryAccordionItemData[], option: CategoryAccordionListOption = {}) {
    super([
      {
        id: undefined,
        name: ET('mps2::product::all'),
        name_en: ET('mps2::product::all'),
        _: { cate_items: [] },
      },
      ...data,
    ]);

    this.state = option;
    this.AccordionItems = pipe(
      this.data,
      map((cate_list) => {
        const is_opened = cate_list.id === this.state.cate_list_id;
        const itemView = new CategoryAccordionItem(cate_list, {
          is_opened,
          active_cate_item_id: this.state.cate_item_id,
        });

        if (is_opened) {
          this.activeCategoryAccordionItem = itemView;
        }

        return itemView;
      }),
      toArray,
    );
  }

  override onRender() {
    this.delegate(CategoryAccordionItemChangeEvent, CategoryAccordionItem, (e, view) => {
      if (this.state.cate_list_id !== e.detail.cate_list_id) {
        this.dispatchEvent(CategoryChangeEvent, {
          bubbles: true,
          detail: e.detail,
        });

        if (this.activeCategoryAccordionItem) {
          this.activeCategoryAccordionItem.close();
          this.activeCategoryAccordionItem.redraw();
        }

        view.open();
        view.redraw();
        this.activeCategoryAccordionItem = view;
      } else if (this.state.cate_item_id !== e.detail.cate_item_id) {
        this.dispatchEvent(CategoryChangeEvent, {
          bubbles: true,
          detail: e.detail,
        });
        view.redraw();
      }

      this.state.cate_list_id = e.detail.cate_list_id;
      this.state.cate_item_id = e.detail.cate_item_id;
    });
  }

  override template() {
    return html`<div class="${klass.container} ${this.state.klass}">${this.AccordionItems}</div>`;
  }

  closeAll() {
    this.AccordionItems.forEach((item) => item.close());
  }
}
